export default "__VITE_ASSET__BapCkRF___"